<!-- 新增业主弹窗 -->
<template>
	<dialogBody @confirm="confirm" @cancel="cancel" ref="body">
		<template slot="title">
			{{title}}
		</template>
		<p class="areaTitle">业主信息</p>
		<div>
			<div class="formContainer">
				<label><span class="required">*</span>业主编号</label>
				<input type="text" v-model.trim="userData.rfid" disabled />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>业主姓名</label>
				<input type="text" v-model.trim="userData.username" disabled />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>性&#x3000;&#x3000;别</label>
				<span class="radio" :class="{'radioSelected':userData.gender == '男'}" @click="userData.gender = '男'"><span class="radioIcon"><span></span></span><span>男</span></span>
				<span class="radio" :class="{'radioSelected':userData.gender == '女'}" @click="userData.gender = '女'"><span class="radioIcon"><span></span></span><span>女</span></span>
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>联系方式</label>
				<input type="text" v-model.trim="userData.mobile" disabled />
			</div>
			<div class="formContainer">
				<label><span></span>地&#x3000;&#x3000;址</label>
				<input type="text" v-model.trim="userData.address" disabled />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>余额告警值</label>
				<input type="number" v-model.trim="userData.balanceAlarm" maxlength="20" disabled/>
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>欠费是否自动拉闸</label>
				<span class="radio" :class="{'pullBrakeSelected':userData.isAutomaticBrake == '1'}" @click="userData.isAutomaticBrake = '1'"><span class="radioIcon"><span></span></span><span>是</span></span>
				<span class="radio" :class="{'pullBrakeSelected':userData.isAutomaticBrake == '0'}" @click="userData.isAutomaticBrake = '0'"><span class="radioIcon"><span></span></span><span>否</span></span>
				<input v-show="userData.isAutomaticBrake=='1'" type="number" v-model.trim="userData.amountOfArrears" maxlength="20" disabled/>
			</div>
			<div class="formContainer">
				<label>开户银行</label>
				<span class="bankName">{{bankList[userData.cardTypes]}}</span>
			</div>
			<div class="formContainer">
				<label>银行卡号</label>
				<input type="text" v-model.trim="userData.cardNumbers" disabled />
			</div>
			<div class="formContainer">
				<label><span class="required">*</span>登&nbsp;&nbsp;录&nbsp;&nbsp;名</label>
				<input type="text" v-model.trim="userData.usercode" disabled />
			</div>
		</div>
		<p class="areaTitle">关联设备</p>
		   <table class="associatedDevice" cellpadding="0" cellspacing="0">
		   	  <tr>
		   	  	<th>设备名称</th>
		   	  	<th>基本电费分摊</th>
		   	  </tr>
		   	  <tr v-for="item in bindDevice">
		   	  	<td>{{item.deviceName}}</td>
		   	  	<td>{{item.deductionStandard}}</td>
		   	  </tr>
		   </table>
	</dialogBody>
</template>

<script>
	import dialogBody from '@/components/module/dialog/dialogBody.vue'
	import singleSelection from '@/components/module/selection/singleSelection.vue'
	import ownerManagerStore from '../ownerManagerStore.js'
	export default {
		components: {
			dialogBody,
			singleSelection
		},
		props: {
			
		},
		data() {
			return {
				title: '',
				callback: undefined,
				bindDevice: '',
				userData: {
					id: '',
					rfid: '',
					username: '',
					userCode: '',
					gender: '男',
					mobile: '',
					address: '',
					password: '',
					password2: '',
					balanceAlarm:'',
					isAutomaticBrake:'1',
					amountOfArrears:'',
				},
				bankList: {
					'CCB':'中国建设银行',
					'ABC':'中国农业银行',
					'ICBC':'中国工商银行',
					'BOC':'中国银行',
					'CMBC':'中国民生银行',
					'CMB':'招商银行',
					'CIB':'兴业银行',
					'BCM':'交通银行'
				}
			}
		},
		computed: {
			
		},
		watch: {},
		mounted() {},
		methods: {
			confirm() {
				this.close()
			},
			cancel() {
				this.close()
			},
			close() {
				this.$refs.body.hide()
			},
			open(title, userData) {
				this.title = title
				this.userData = copy(userData)
				this.userData.cardTypes = userData.cardType
				this.userData.cardNumbers = userData.cardNumber
				this.$refs.body.open()
				this.$api.meterReadingApi.getDeviceListByOwner(userData.id, respon => {
					this.bindDevice = respon
				})
			},
		}
	}
</script>
<style scoped>
	.areaTitle {
		line-height: 36px;
		background-color: #F2F2F2;
		padding-left: 20px;
		margin-bottom: 10px;
	}
	
	.formContainer{
		margin-bottom: 12px;
	}
	
	.formContainer>label{
		min-width: 92px;
		text-align: right;
		display: inline-block;
		margin-right: 12px;
		line-height: 32px;
	}
	
	.formContainer>label>span{
		display: inline-block;
		width: 8px;
	}
	
	
	.formContainer>>>.selection-body{
		display: inline-flex;
		padding: 0;
		margin-right: 20px;
	}
	
	.formContainer>>>.selection>p{
		line-height: 32px;
		height: 32px;
		padding: 0;
	}
	
	.required{
		color: red;
	}
	
	.selectTime{
		display: inline-block;
		border: solid 1px #DCDFE6;
		color: #DCDFE6;
		min-width: 180px;
		padding: 0 10px;
		line-height: 30px;
		border-radius: 4px;
	}
	
	.radio{
		height: 32px;
		padding: 9px 0;
		margin-right: 20px;
		cursor: pointer;
	}
	
	.radioIcon{
		display: inline-block;
		box-sizing: border-box;
		width: 14px;
		height: 14px;
		background-color: #FFFFFF;
		border-radius: 50%;
		border: solid 1px #E4E4E4;
		margin-right: 6px;
		vertical-align: middle;
	}
	
	.radioIcon:hover{
		border-color: #409EFF;
	}
	
	.radioSelected>.radioIcon{
		background-color: #409EFF;
		border: none;
	}
	.pullBrakeSelected>.radioIcon{
		background-color: #409EFF;
		border: none;
	}
	
	.radioIcon>span{
		display: inline-block;
		width: 4px;
		height: 4px;
		border-radius: 50%;
		background-color: #FFFFFF;
		margin: 5px;
	}
	
	.addRelatedDevice{
		text-align: center;
		line-height: 32px;
		color: #CECECE;
		border: dashed 2px #CECECE;
		border-radius: 6px;
		background-color: #F2F2F2;
		cursor: pointer;
	}
	
	.bindDevice{
		background-color: #F2F2F2;
		border: solid 1px #CCCCCC;
		line-height: 32px;
		border-radius: 6px;
		padding: 0 10px;
	}
	
	.bankName{
		display: inline-block;
		width: 170px;
		height: 30px;
		vertical-align: bottom;
		line-height: 30px;
		border: solid 1px #C0C0C0;
		border-radius: 6px;
		padding: 0 10px;
	}
	.associatedDevice{
		width: 100%;
	}
	.associatedDevice tr th{
		text-align: left;
		color: #909399;
		padding: .1rem 0 .1rem 0;
		border-bottom: .01rem solid #dfe0e0;
	}
	.associatedDevice tr td{
		padding: .1rem 0 .1rem 0;
		color: #909399;
		border-bottom: .01rem solid #dfe0e0;
	}
</style>